
























import Vue from 'vue';

export default Vue.extend({

    props: ["text", "restrictAt", "isRestricted"],

    data(){
        return {
            restrict: this.isRestricted
        }
    }

})
